import { createReducer, ActionType } from 'typesafe-actions';
import type { ViewsModels } from '../types';
import { FETCH_RELATED_SERVICES, RESET_RELATED_SERVICES } from './actions';

type RelatedServicesActions =
  | ActionType<typeof FETCH_RELATED_SERVICES>
  | ActionType<typeof RESET_RELATED_SERVICES>;

export type RelatedServicesStoreData =
  | {
      state: 'request';
    }
  | {
      state: 'success';
      data: ViewsModels.RelatedServiceSuccessResponse;
    }
  | {
      state: 'failure';
      error: {
        message: string;
      };
    }
  | {
      state: 'cancel';
    };
export const relatedServices = createReducer<RelatedServicesStoreData | null, RelatedServicesActions>(null)
  .handleAction(FETCH_RELATED_SERVICES.request, () => ({ state: 'request' }))
  .handleAction(FETCH_RELATED_SERVICES.success, (_, { payload }) => ({
    state: 'success',
    data: payload,
  }))
  .handleAction(FETCH_RELATED_SERVICES.failure, (_, { payload }) => ({
    state: 'failure',
    error: {
      message: payload.message,
      cause: payload.cause,
    },
  }))
  .handleAction(FETCH_RELATED_SERVICES.cancel, () => ({ state: 'cancel' }))
  .handleAction(RESET_RELATED_SERVICES, () => null);
